import { useDispatch, useSelector } from "react-redux";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { Header } from "../../components";
import Footer from "../../components/Footer";
import HeaderLogo from "../../components/HeaderLogo";
import RequiredDocumentsPage from "../Dashboard/RequiredDocumentsPage";
import RejectedClient from "../Dashboard/rejectedClient";
import DraftClient from "../Dashboard/draftClient";
import PendingClient from "../Dashboard/PendingClient";
import KYCRequired from "../KYCRequired";
import { useModules } from "../../hooks";
import { useEffect, useState } from "react";
import { getModuleStatus } from "../../redux/actions/lookups/getModuleStatus";
import DraftClientSumSub from "../Dashboard/draftClientSumSub";
import LoadingSpinner from "../../components/Common/LoadingSpinner";

const PrivateRoutes = () => {
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const location = useLocation();

  const isSumSubEnabled = useModules("Sumsub");
  const [hasFetchedStatus, setHasFetchedStatus] = useState(false);

  useEffect(() => {
    const checkModule = async () => {
      // if (user && ["Draft", "Update"].includes(user.status)) {
      if (user) {
        try {
          await dispatch(getModuleStatus({ module: "Sumsub" }));
        } catch (error) {
          console.error("Failed to fetch module status", error);
        } finally {
          setHasFetchedStatus(true);
        }
      } else {
        setHasFetchedStatus(true);
      }
    };

    if (!hasFetchedStatus) {
      checkModule();
    }
  }, [dispatch, hasFetchedStatus, user]);

  if (!user || !user.token) {
    return <Navigate to="/signin" />;
  }

  if (
    location.state?.isSubAccount &&
    location.state?.sub_client_id &&
    location.state?.sub_user_id
  ) {
    const subUser = {
      ...user,
      id: location.state.sub_user_id,
      client_id: location.state.sub_client_id,
      account_type: location.state.account_type,
      status: "Liveness Done",
    };

    return (
      <>
        <HeaderLogo />
        <RequiredDocumentsPage user={subUser} isSubAccount={true} />
        <Footer />
      </>
    );
  }

  if (!hasFetchedStatus) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  const registrationFlow = [
    "Draft",
    "Liveness Done",
    "Pending",
    "Rejected",
    "Update",
  ].includes(user.status);

  if ((user.status === "Approved" || "Pending") && user.kyc_requested === 1) {
    return <KYCRequired />;
  }

  return (
    <>
      {registrationFlow ? <HeaderLogo /> : <Header />}
      {user.token && (
        <>
          {(() => {
            switch (user.status) {
              case "Draft":
              case "Update":
                return isSumSubEnabled ? (
                  <DraftClientSumSub />
                ) : (
                  <DraftClient />
                );
              case "Liveness Done":
                return <RequiredDocumentsPage user={user} />;
              case "Pending":
                return <PendingClient />;
              case "Rejected":
                return <RejectedClient rejectedReason={user.message} />;
              default:
                return <Outlet />;
            }
          })()}
        </>
      )}
      <Footer />
    </>
  );
};

export default PrivateRoutes;
